// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1KpS5","overflowing":"ReadFullNote_overflowing__2MIO8"};